// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__2hX13","cont":"style_cont__2wrIV","form":"style_form__dUnG_","submitBtn":"style_submitBtn__3eq-r"};